<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de personalidad</option>        
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de personalidad</option>
        <option v-for="TipoDePersonalidad in TiposDePersonalidades" :value="TipoDePersonalidad.TipoPersonalidadId">{{TipoDePersonalidad.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import { mapActions } from 'vuex'

  export default {
    data: () =>{
      return {
        enumeraciones,
        comun,
        TiposDePersonalidades: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() { 
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer029TipoPersonalidad", parametros);
    },
    methods: {
      cargaCatalogoDeTiposDePersonalidades() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      

        axios.post(api.conexion + api.PJ.catalogos.C029TipoPersonalidad, this.parametros)      
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
                this.TiposDePersonalidades = respuesta.data.TiposPersonalidad;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer029TipoPersonalidad", parametros);
        this.$emit("valorParaElPadre", evento);        
      }
    },
    created() {
      this.cargaCatalogoDeTiposDePersonalidades();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/029TipoPersonalidad.vue